import { Component, Input } from '@angular/core';
import { ScenicCardComponent } from '@kinomap-dev/ng-ui-lib';
import {
  Workout,
  VideoSection,
  Coaching,
  GpsOnly,
  Information,
} from '@kinomap-dev/ng-ui-lib/lib/models';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { User } from 'app/models';
import { ToasterService } from 'app/services/toaster.service';

@Component({
  standalone: true,
  imports: [ScenicCardComponent, TranslateModule],
  templateUrl: './scenics-modal.component.html',
  styleUrl: './scenics-modal.component.scss',
})
export class ScenicsModalComponent {
  @Input() title!: string;
  @Input() client: User | null = null;
  @Input() items!: Workout[] | VideoSection[] | Coaching[] | GpsOnly[];

  constructor(
    private router: Router,
    private toasterService: ToasterService,
    private translate: TranslateService
  ) { }

  onCardClick(item: Information): void {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      const type: string = item.type === 'scenic' ? 'watch' : item.type;
      this.router.navigate([`/browse/${type}`, item.id]);
    });
    return;
  }

  onAuthorClick(item: Information) {
    if (!this.client) {
      this.toasterService.warning(
        null,
        this.translate.instant(
          'toaster.errors.notLoggedIn.messages.toAccessFeature'
        )
      );
      return false;
    }

    if (item.author && item.author.id) {
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.router.navigate(['/dashboard/profile', item.author.id, item.id]);
      });
      return;
    }
  }
}
